import { Button, Modal, Select, Spinner, Textarea } from "@aqar-app/react-ui";
import { useMutation } from "@apollo/client";
import { useAuthState } from "../../../../contexts/auth/auth.provider";
import {
  trackGenericCTAClickEvent,
  trackReportItem,
} from "../../../../lib/tracking/trackNavigationEvents";
import { REPORT } from "../../../../graphql/mutations/report";
import logger from "../../../../../console";
import css from "./.module.scss";
import useForm from "../../../../hooks/useForm";
import FieldError from "../../../field-error/FieldError";
import LoginAlert from "../../../login-alert";
import { Icon } from "@/components/icon";
import React from "react";
import { ClassicModal } from "@/components/Listing/ListingScreen/classicModal";
import { usePath } from "@/contexts/path/path";

const reasonOptions = [
  { value: "wrong_price", label: "السعر خطأ" },
  { value: "wrong_location", label: "الموقع خطأ" },
  { value: "rega_noncompliance", label: "مخالف لشروط الهئية العامة للعقار" },
  { value: "expired_listing", label: "إعلان قديم" },
  { value: "other", label: "سبب آخر" },
];

const noValidation = () => ({});

function ReportForm({ listingID }) {
  const { token } = useAuthState();
  const { values, handleChange, handleSubmit } = useForm(
    // eslint-disable-next-line no-use-before-define
    submitReport,
    noValidation,
  );
  const [success, setSuccess] = React.useState(false);

  const [reportMutation, { error, loading }] = useMutation(REPORT, {
    context: { token },
    onCompleted: () => {
      setSuccess(true);
    },
    onError: (err) => {
      logger.error(err.message);
    },
  });

  function submitReport(e) {
    const variables = {
      id: listingID,
      content: values.content,
      reason: values.reason,
    };

    // trackSubmitListingReport(variables);

    return reportMutation({ variables }).then(() => {
      trackReportItem(`${values?.reason}-${values?.content}`);
    });
  }

  return (
    <ClassicModal
      title="بلغ عن الإعلان"
      body={
        success ? (
          <p>تم إرسال البلاغ بنجاح</p>
        ) : (
          <div className={css.body}>
            <div className={css.reportBody}>
              <Select
                className={css.select}
                onSelect={(selectedValue) =>
                  handleChange(undefined, { reason: selectedValue })
                }
                placeholder="الرجاء اختيار السبب..."
              >
                {reasonOptions?.map((opt) => (
                  <Select.Option key={opt.value} value={opt.value}>
                    <p>{opt.label}</p>
                  </Select.Option>
                ))}
              </Select>
              <Textarea
                name="content"
                onChange={handleChange}
                placeholder="نص البلاغ..."
              />
              {error && <FieldError text={error.message} />}
            </div>
          </div>
        )
      }
      ok={
        success
          ? { label: "إغلاق", cb: Modal.close }
          : {
              jsx: (
                <Button
                  outline
                  theme="primary"
                  disabled={!values.reason || loading}
                  onClick={handleSubmit}
                >
                  {loading ? <Spinner /> : null}
                  إرسال
                </Button>
              ),
            }
      }
      {...(success ? { cancel: null } : {})}
    ></ClassicModal>
  );
}

function ReportButton({ listingID, ...props } = {}) {
  const { token } = useAuthState();
  const { category } = usePath();

  const handleReportClick = (e) => {
    if (!token) {
      Modal.open(<LoginAlert text="يرجى تسجيل الدخول لاتمام البلاغ " />)(e);
    } else {
      trackGenericCTAClickEvent(e, {
        listing_type: category?.ga_listing_type,
        property_category: category?.ga_property_category,
      });
      Modal.open(<ReportForm listingID={listingID} />)(e);
    }
  };
  return (
    <button
      type="button"
      onClick={handleReportClick}
      data-event-target="report_listing"
      {...props}
    >
      <Icon width={20} height={20} name="Report-black" />
      بلغ على الإعلان
    </button>
  );
}

export default ReportButton;
